//
//
//
//
//
//
//

import GroupEntrance from './GroupEntrance';
import Fold from './Fold';
export default {
  name: 'group-collection',
  components: {
    'v-fold': Fold,
    'v-group-entrance': GroupEntrance
  },
  data: function data() {
    return {
      entranceHeight: 80,
      maxEntranceCount: 2
    };
  },
  computed: {
    maxFoldHeight: function maxFoldHeight() {
      return this.entranceHeight * this.maxEntranceCount;
    }
  },
  props: {
    groups: Array
  }
};